<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('series.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('series.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'series-search' }">{{ $t('series.list.search.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'live-streaming-series' }" v-if="$i18n.locale === 'tw'">{{ $t('series.livestream-list.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'ongoing-series' }" active>{{ $t('series.list.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col">
          <b-nav pills fill>
            <b-nav-item-dropdown :text="$t('series.list.recently-updated.title')" active>
              <b-dropdown-item :to="{ name: 'ongoing-series' }">{{ $t('series.list.recently-updated.ongoing.title') }}</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'recently-added-series' }">{{ $t('series.list.recently-updated.recently-added.title') }}</b-dropdown-item>
              <!-- <b-dropdown-item :to="{ name: 'updated-series' }">{{ $t('series.list.recently-updated.updated.title') }}</b-dropdown-item> -->
            </b-nav-item-dropdown>
            <b-nav-item :to="{ name: 'classified-series' }">{{ $t('series.list.classified.title') }}</b-nav-item>
            <b-nav-item :to="{ name: 'series-search' }" active>{{ $t('series.list.search.title') }}</b-nav-item>
          </b-nav>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <b-form @submit="submitKeyword">
            <b-input-group size="lg">
              <b-form-input
                :placeholder="$t('series.list.search.search-bar.keyword-inputor.hint')"
                v-model="keyword"
                style="border-color: black; color: black"
              ></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="primary">{{ $t('series.list.search.search-bar.search-button.label') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </div>
      </div>
      <series-card-list :series="series" v-if="this.search_completed && series.length > 0"></series-card-list>
      <div class="row mt-3" v-if="this.search_completed && series.length > 0">
        <div class="col">
          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
            align="center"
            size="lg"
          ></b-pagination>
        </div>
      </div>
      <div class="row mt-3" v-if="this.search_completed && series.length === 0">
        <div class="col-12">
          <h5 class="text-danger font-weight-bold">{{ $t('series.list.search.message.no-result') }}</h5>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import SeriesCardList from '@/components/lists/SeriesCardList'

import i18n from '@/plugins/i18n.js'

import SeriesApiService from '@/services/budaedu-api-services/series-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(SeriesApiService)

export default {
  i18n,
  name: 'series-search',
  data() {
    return {
      is_loading: false,
      keyword: '',
      search_completed: false,
      per_page: 30,
      page: 1,
      total: 0,
      series: []
    }
  },
  methods: {
    pageChange(page) {
      this.page = page
      this.setSeries()
    },
    submitKeyword(event) {
      event.preventDefault()
      this.setSeries()
    },
    getFilter() {
      let filter = { IsDirtyEntry: 'N' }
      if (this.$i18n.locale === 'en') {
        filter.cag_no = 'C016,C025,C036'
      }
      return filter
    },
    async setSeries() {
      this.is_loading = true
      this.series = []
      try {
        let items = {}
        const additional = stringify({
            filter: this.getFilter(),
            order: 'cdate,desc',
            per_page: this.per_page,
            page: this.page
        }).substr(1)

        if (this.keyword != '') {
          items = await this.$seriesApiService.queryByKeyword(this.keyword, additional)
        } else {
          items = await this.$seriesApiService.query(additional)
        }

        this.series = items.data
        this.total = items.meta.total
        this.search_completed = true
      } finally {
        this.is_loading = false
      }
    }
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
  },
  components: {
    SeriesCardList
  },
  metaInfo() {
    return {
      title: `${this.$t('series.list.search.title')}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>